import styled from 'styled-components'

export const Card = styled.div`
  display: flex;
  flex-direction: column;
  overflow: hidden;
  border-radius: ${props => props.theme.radius.infoMessage};
`

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 112px;
  padding: 0 ${props => props.theme.spacing.sp16};
  background-image: url('/images/smart-tracking-upsell.jpg');
  background-size: cover;
  background-position: center;
`

export const HeaderFrame = styled.div`
  position: relative;
  width: 100%;
  padding: ${props => props.theme.spacing.sp8};
  color: ${props => props.theme.colors.text.inverse};

  &::before,
  &::after {
    content: '';
    position: absolute;
    pointer-events: none;
  }

  &::before {
    top: -2px;
    bottom: -2px;
    left: 2.5%;
    right: 2.5%;
    border-left: 1px solid ${props => props.theme.palette.whiteAlpha.alpha50};
    border-right: 1px solid ${props => props.theme.palette.whiteAlpha.alpha50};
  }

  &::after {
    top: ${props => props.theme.spacing.sp8};
    bottom: ${props => props.theme.spacing.sp8};
    left: 0;
    right: 0;
    border-top: 1px solid ${props => props.theme.palette.whiteAlpha.alpha50};
    border-bottom: 1px solid ${props => props.theme.palette.whiteAlpha.alpha50};
  }
`

export const HeaderScrim = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: ${props => props.theme.spacing.sp8} ${props => props.theme.spacing.sp16};
  background-color: ${props => props.theme.colors.overlay.scrim};
  text-align: center;
`

export const Body = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp8};
  padding: ${props => props.theme.spacing.sp12} ${props => props.theme.spacing.sp16};
  background-color: ${props => props.theme.colors.primary.surface};
`
